import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgxEzModalService } from '../../../../../../shared/modules/ngx-ez-modal/ngx-ez-modal.service';

@Component({
  selector: 'app-apex-lp-select-modal',
  templateUrl: './apex-lp-select-modal.component.html',
  styleUrls: ['./apex-lp-select-modal.component.scss']
})
export class ApexLpSelectModalComponent implements OnDestroy {
  @Input() maxMatches: number;
  @Input() rankName: string;
  @Input() lps = {
    'rookie': [
      { minLp: 0, maxLp: 49 },
      { minLp: 50, maxLp: 99 },
      { minLp: 100, maxLp: 149 },
      { minLp: 150, maxLp: 199 },
      { minLp: 200, maxLp: 249 }
    ],
    'bronze': [
      { minLp: 0, maxLp: 99 },
      { minLp: 100, maxLp: 199 },
      { minLp: 200, maxLp: 299 },
      { minLp: 300, maxLp: 399 },
      { minLp: 400, maxLp: 499 }
    ],
    'silver': [
      { minLp: 0, maxLp: 119 },
      { minLp: 120, maxLp: 239 },
      { minLp: 240, maxLp: 359 },
      { minLp: 360, maxLp: 479 },
      { minLp: 480, maxLp: 599 }
    ],
    'gold': [
      { minLp: 0, maxLp: 139 },
      { minLp: 140, maxLp: 279 },
      { minLp: 280, maxLp: 419 },
      { minLp: 420, maxLp: 559 },
      { minLp: 560, maxLp: 699 }
    ],
    'platinum': [
      { minLp: 0, maxLp: 159 },
      { minLp: 160, maxLp: 319 },
      { minLp: 320, maxLp: 479 },
      { minLp: 480, maxLp: 639 },
      { minLp: 640, maxLp: 799 }
    ],
    'diamond': [
      { minLp: 0, maxLp: 179 },
      { minLp: 180, maxLp: 359 },
      { minLp: 360, maxLp: 539 },
      { minLp: 540, maxLp: 719 },
      { minLp: 720, maxLp: 899 }
    ],
  };
  @Input() disablePromos = false;
  @Input() lang: string;

  @Output() selected = new EventEmitter<string | number>();
  private promoModalSub: Subscription;

  constructor(public modalService: NgxEzModalService) { }

  onSelect(lp) {
    this.selected.emit(lp);
    this.modalService.closeOutletModals('public');
  }

  ngOnDestroy() {
    if (this.promoModalSub) {
      this.promoModalSub.unsubscribe();
    }
  }
}